import dayjs from 'dayjs';
import { useState } from 'react';

import { useGetProjectWorktimeGroupByDateQuery } from '@/hook';
import type { Project } from '@/type';

import { WORKTIME_PERIOD_UNIT, WorkFlowPerformance } from '../Statistic';
import type { PeriodUnit } from '../Statistic/type';

export const ProjectWorkFlowPerformance = ({
  project,
}: {
  project: Project;
}) => {
  const [dateRange, setDateRange] = useState([
    dayjs().utc().startOf('day').subtract(15, 'day').toDate(),
    dayjs().utc().endOf('day').toDate(),
  ] as [Date, Date]);
  const [periodUnit, setPeriodUnit] = useState(
    WORKTIME_PERIOD_UNIT.DAILY.value as PeriodUnit,
  );
  const { data: worktimeGroupByDate } = useGetProjectWorktimeGroupByDateQuery({
    projectID: project.id,
    between: dateRange.map(v => v.toISOString()) as [string, string],
  });

  return worktimeGroupByDate ? (
    <WorkFlowPerformance
      dateRange={dateRange}
      periodUnit={periodUnit}
      worktimeGroupByDate={worktimeGroupByDate}
      onChangeDateRange={setDateRange}
      onChangePeriodUnit={setPeriodUnit}
    />
  ) : null;
};

ProjectWorkFlowPerformance.displayName = 'ProjectWorkFlowPerformance';
